module.exports = __webpack_public_path__ + "media/images/icon/checkbox-e87b98400884fd67f2a9f58ecd23ff8e.svg";